<template>
    <div class="mt-4">
        <VerificationSubsection title="Personal Data Check">
            <VerificationFullRow
                :check-result="knownYourCustomer.name"
                label="Full Name:"
            />
            <VerificationFullRow
                :check-result="knownYourCustomer.dateOfBirth"
                label="Date of Birth:"
            />
            <VerificationFullRow
                :check-result="knownYourCustomer.ssn"
                omit-check-text
            >
                <div>{{ country === 'US' ? 'Social Security Number:' : 'ID Number:' }}</div>
                <div>{{ knownYourCustomer.ssn.text }}</div>
            </VerificationFullRow>
            <VerificationFullRow
                :check-result="knownYourCustomer.phone"
                label="Phone Number:"
            />
            <VerificationFullRow
                :check-result="knownYourCustomer.deceased"
                label="Deceased Check"
                omit-check-text
            >
                <template #check-result>
                    <CheckStateResult
                        v-if="country === 'US'"
                        :value="knownYourCustomer.deceased"
                    />
                    <div
                        v-else
                        class="text-sm font-semibold"
                    >
                        Available for US Only
                    </div>
                </template>
            </VerificationFullRow>
        </VerificationSubsection>
        <VerificationSubsection title="Address Check">
            <VerificationFullRow
                :indentationLevel="1"
                omit-check-text
            >
                <div class="text-base font-bold">{{ knownYourCustomer.address.text }}</div>
            </VerificationFullRow>
            <VerificationFullRow
                :check-result="knownYourCustomer.poboxDetection"
                :indentationLevel="2"
                label="Is the address a P.O. Box?"
                omit-check-text
            />
            <VerificationFullRow
                :check-result="knownYourCustomer.addressDeliverableDetection"
                :indentationLevel="2"
                label="Is the address deliverable?"
                omit-check-text
            />
            <VerificationFullRow
                :check-result="knownYourCustomer.addressResidentialDetection"
                :indentationLevel="2"
                label="Is the address residential?"
                omit-check-text
            />
            <VerificationFullRow
                :check-result="knownYourCustomer.address"
                :indentationLevel="1"
                label="Is the address provided sufficiently associated with the client?"
            />

            <VerificationFullRow
                :check-result="knownYourCustomer.streetAddress"
                :indentationLevel="2"
                label="Street Address:"
                omit-error-list
            />

            <VerificationFullRow
                :check-result="knownYourCustomer.city"
                :indentationLevel="2"
                label="City:"
                omit-error-list
            />

            <VerificationFullRow
                :check-result="knownYourCustomer.state"
                :indentationLevel="2"
                label="State:"
                omit-error-list
            />

            <VerificationFullRow
                :check-result="knownYourCustomer.zipCode"
                :indentationLevel="2"
                label="Zip Code:"
                omit-error-list
            />

            <VerificationFullRow
                :check-result="knownYourCustomer.country"
                :indentationLevel="2"
                label="Country:"
                omit-error-list
            />
        </VerificationSubsection>
    </div>
</template>

<script lang="ts" setup>
import type { KnownYourCustomerAnalysis } from '@/api/interfaces/identity-verification-report.api';
import CheckStateResult from '../common/CheckStateResult.vue';
import VerificationFullRow from '../common/VerificationFullRow.vue';
import VerificationSubsection from '../common/VerificationSubsection.vue';

withDefaults(defineProps<{ knownYourCustomer: KnownYourCustomerAnalysis; country: string }>(), { country: 'US' });
</script>
